export default [
    {
      path: '/orders/order',
      meta: {
        title: '全部订单',
      },
      component: () => import('@/views/orders/supplyOrder/index'),
    },
    {
      path: '/orders/platformOrder',
      meta: {
        title: '增值订单',
      },
      component: () => import('@/views/orders/platformOrder'),
    },
    {
      path: '/orders/aftersale',
      meta: {
        title: '售后订单',
      },
      component: () => import('@/views/orders/aftersale/index'),
    },
  ]
